import { OrderingMethodNames, OrderOnSpotCustomMethod, OrderOnSpotCustomMethodLocation } from '@eo-storefronts/eo-core'
import { useEffect } from 'react'
import EatInLocationError from '~/src/components/dialogs/eat-in-location'
import useDialog from '~/src/hooks/useDialog'
import { useEoState, useEoValue, useSetEoState } from '~/src/hooks/useEoState'
import { CHECKOUT_FORM_STATE, FROZEN_DELIVERY_METHOD_STATE } from '~/src/stores/checkout'
import { FIRM_SELECTOR } from '~/src/stores/firm'

const useCheckTableEffect = (): void => {
  const firm = useEoValue(FIRM_SELECTOR)
  const [ checkoutForm, setCheckoutForm ] = useEoState(CHECKOUT_FORM_STATE)
  const setFrozenDeliveryMethod = useSetEoState(FROZEN_DELIVERY_METHOD_STATE)
  const { present } = useDialog()

  const _errorHandling = () => {
    present(EatInLocationError, 'eat-in-location-error')
    setCheckoutForm((state) => ({
      ...state,
      orderingMethod: {
        ...state.orderingMethod,
        tableMethod: null,
        tableNumber: null,
        tableUid: null
      }
    }))
    setFrozenDeliveryMethod(false)
  }

  useEffect(() => {
    if (
      checkoutForm.orderingMethod.method !== OrderingMethodNames.ON_THE_SPOT
      || checkoutForm.orderingMethod.tableMethod === null
      || checkoutForm.orderingMethod.tableNumber === null
      || checkoutForm.orderingMethod.tableUid === null
    ) {
      return
    }
    
    const customMethod: OrderOnSpotCustomMethod | undefined = firm?.settings.orderingMethods
      .table?.customMethods?.find((customMethod: OrderOnSpotCustomMethod) => customMethod.id === Number(checkoutForm.orderingMethod.tableMethod))

    if (!customMethod) {
      _errorHandling()
      return
    }

    const location: OrderOnSpotCustomMethodLocation | undefined = customMethod.locations
      .find((l: OrderOnSpotCustomMethodLocation) => l.name === checkoutForm.orderingMethod.tableNumber)

    if (!location) {
      _errorHandling()
      return
    }
  }, [
    firm,
    checkoutForm.orderingMethod.method,
    checkoutForm.orderingMethod.tableMethod,
    checkoutForm.orderingMethod.tableNumber,
    checkoutForm.orderingMethod.tableUid
  ])
}

export { useCheckTableEffect }
